import { useContext } from 'react';

import { BrandAnalysisMutationsContext } from './BrandAnalysisMutationsContext';

import type { BrandAnalysisMutations } from './types';

export const useBrandAnalysisMutations = (): BrandAnalysisMutations => {
  const context = useContext(BrandAnalysisMutationsContext);
  if (context === undefined) {
    throw new Error(
      'useBrandAnalysisMutations must be used within a BrandAnalysisMutationsProvider',
    );
  }
  return context.mutations;
};
